// Sales pricing calculator (Gravity admin-settings/pricing). One field list drives the Defaults tab,
// the calculator's knobs, and the API's validation of saved defaults, so the three cannot drift.
//
// Constants are list prices and deal rules; they are edited only in the Defaults tab. The sales
// commission rate is deliberately absent: each seller enters their own rate in the calculator.
// Starting values are where the calculator's knobs sit when it opens or is reset.
// `seed` is the value used until an admin saves defaults for the first time.

export const PRICING_CALCULATOR_CONSTANT_FIELDS = [
  { key: 'standardConnectorPrice', label: 'Standard connector', unit: 'usdPerYear', seed: 5000 },
  { key: 'premiumConnectorPrice', label: 'Premium connector (e.g. NetSuite)', unit: 'usdPerYear', seed: 10000 },
  { key: 'builderPrice', label: 'Analytics builder', unit: 'usdPerYear', seed: 1920 },
  { key: 'editorPrice', label: 'Analytics editor (0 = price TBD)', unit: 'usdPerYear', seed: 0 },
  { key: 'viewerPrice', label: 'Analytics viewer', unit: 'usdPerYear', seed: 120 },
  { key: 'proSeatPrice', label: 'Cirra Pro seat', unit: 'usdPerYear', seed: 2400 },
  { key: 'standardSeatPrice', label: 'Cirra Standard seat', unit: 'usdPerYear', seed: 360 },
  { key: 'premiumMinimumSpend', label: 'Minimum annual spend to unlock premium connectors', unit: 'usd', seed: 10000 },
  { key: 'aiCommissionPct', label: "Commission on AI portion, as % of the seller's rate", unit: 'percent', seed: 50, max: 100 },
  { key: 'aiPassThroughMinPct', label: 'AI pass-through target minimum, as % of deal', unit: 'percent', seed: 0, max: 100 },
  { key: 'aiPassThroughMaxPct', label: 'AI pass-through target maximum, as % of deal', unit: 'percent', seed: 30, max: 100 }
];

export const PRICING_CALCULATOR_STARTING_VALUE_FIELDS = [
  { key: 'standardConnectors', label: 'Standard connectors', unit: 'count', seed: 5 },
  { key: 'premiumConnectors', label: 'Premium connectors', unit: 'count', seed: 0 },
  { key: 'builders', label: 'Analytics builders', unit: 'count', seed: 5 },
  { key: 'editors', label: 'Analytics editors', unit: 'count', seed: 0 },
  { key: 'viewers', label: 'Analytics viewers', unit: 'count', seed: 50 },
  { key: 'markdownPct', label: 'Starting discount for each analytics row', unit: 'percent', seed: 0, max: 100 },
  { key: 'proSeats', label: 'Cirra Pro seats', unit: 'count', seed: 5 },
  { key: 'standardSeats', label: 'Cirra Standard seats', unit: 'count', seed: 0 },
  { key: 'sharedUsagePerMonth', label: 'Shared usage / overflow per month', unit: 'usdPerMonth', seed: 1000 }
];

export const PRICING_CALCULATOR_FIELDS = [...PRICING_CALCULATOR_CONSTANT_FIELDS, ...PRICING_CALCULATOR_STARTING_VALUE_FIELDS];
